import { API_URL } from '../../../app-config/constants';
import type { Coach } from '../../react/features/AiCopilot/types';
import { get, post, put, remove } from '../request';

const BASE_URL = `${API_URL}/copilot/admin`;

getAssistants.operation = 'READ';
getAssistants.updateOnCreate = (args: [], x: Coach, xs: Coach[]) => [x, ...xs];
export function getAssistants() {
    return get<Coach[]>(`${BASE_URL}/assistants`);
}

getAssistant.operation = 'READ';
getAssistant.byId = true;
export function getAssistant(id: string) {
    return get<Coach>(`${BASE_URL}/assistants/${id}`);
}

createAssistant.operation = 'CREATE';
export function createAssistant(assistant: Omit<Coach, 'id'>) {
    return post<Coach>(`${BASE_URL}/assistants`, { postData: assistant });
}

updateAssistant.operation = 'UPDATE';
export function updateAssistant(assistant: Coach) {
    return put<Coach>(`${BASE_URL}/assistants/${assistant.id}`, { postData: assistant });
}

deleteAssistant.operation = 'DELETE';
export function deleteAssistant(id: string) {
    return remove(`${BASE_URL}/assistants/${id}`);
}
